/** Accept a domain or a complete work address, then return a strict DNS name. */
export function normalizeSsoDomain(input: string): string | null {
  const value = input.trim().toLowerCase();
  const parts = value.split('@');
  if (parts.length > 2 || (parts.length === 2 && !/^[^\s@]+$/.test(parts[0]))) return null;
  const domain = parts.length === 2 ? parts[1] : value;
  if (!domain || domain.length > 253 || !domain.includes('.')) return null;
  const labels = domain.split('.');
  if (
    labels.some(
      (label) =>
        label.length < 1 || label.length > 63 || !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(label),
    ) ||
    !/^[a-z]{2,63}$/.test(labels.at(-1)!)
  )
    return null;
  return domain;
}
